export default __webpack_public_path__ + "static/media/Female.389750a7.png";